import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface LoginInterface {
  username: string;
  password: string;
}

export const useLogin = () => {
  const mutate = useMutation(({ username, password }: LoginInterface) => {
    return postAPI('/enterprise-api/enterprise_login', {
      email: username,
      password,
    });
  });

  return mutate;
};

export default LoginInterface;
